import { SET_ERROR, CLEAR_ERROR, GET_ERROR, ERROR } from '../constants/actionTypes';

export const getError = () => ({type: GET_ERROR,payload:{type:ERROR}});
export const clearError = () => ({type: CLEAR_ERROR,payload:{type:ERROR}});
export const setError =   (error) =>  {return {type: SET_ERROR,payload:{type:ERROR,message:error}}};